import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()

const EVALUATION="talent_cloud/evaluation"
const EVALUATOR="talent_cloud/evaluation/evaluator"
const QUESTIONS=(evaluator_id)=>`${EVALUATION}/evaluator/${evaluator_id}/questions`
const ACTION_PLAN=()=>`${EVALUATION}/action_plan`
const BULK_CREATION=()=>`${EVALUATION}/bulk_creation`
const ACTION_PLAN_ID=(actionPlanId)=>`${EVALUATION}/action_plan/${actionPlanId}`




export const evaluationGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(`${EVALUATION}`,{params,signal:controller.signal})
    return {call,controller}
}
export const evaluationPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(`${EVALUATION}`, data, {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${EVALUATION}/${id}`, {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${EVALUATION}/${id}`, data, {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationPut = (data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${EVALUATION}`, data, {params, signal:controller.signal})
    return {call,controller}
}

export const evaluationQuestionsGet = ({evaluator_id,params}) => {
    const controller= loadAbort()
    const call= axios.get(`${QUESTIONS(evaluator_id)}`,{params,signal:controller.signal})
    return {call,controller}
}

export const evaluationEvaluatorPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(`${EVALUATOR}/${id}`, data, {params, signal:controller.signal})
    return {call,controller}
}
// ACTION PLAN
export const evaluationActionPlanGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(ACTION_PLAN(),{params,signal:controller.signal})
    return {call,controller}
}
export const evaluationActionPlanPost = (data,params) => {
    const controller= loadAbort()
    const call= axios.post(ACTION_PLAN(), data, {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationActionPlanIdGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(ACTION_PLAN_ID(id),  {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationActionPlanIdPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(ACTION_PLAN_ID(id), data, {params, signal:controller.signal})
    return {call,controller}
}
export const evaluationActionPlanIdDelete = (id,params) => {
    const controller= loadAbort()
    const call= axios.delete(ACTION_PLAN_ID(id),  {params, signal:controller.signal})
    return {call,controller}
}
    export const evaluationBulkCreationPost = (data,params) => {
        const controller= loadAbort()
        const call= axios.post(BULK_CREATION(), data, {params, signal:controller.signal})
        return {call,controller}
    }